import React from 'react';
import { Link } from 'react-router-dom';
import './AuthLayout.css';

const AuthLayout = ({ children }) => {
  
  return (
    <div className="auth-layout">
      {/* Minimal Header */}
      <nav className="navbar auth-navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <Link to="/">
              <img src="/lp-icon.png" alt="Literally Possible Logo" className="nav-logo-img" />
            </Link>
          </div>
          <div className="nav-menu">
            <Link to="/" className="nav-back-link">← Back to Home</Link>
          </div>
        </div>
      </nav>

      {/* Auth Content */}
      <main className="auth-main">
        {children}
      </main>

      {/* Minimal Footer */}
      <footer className="footer auth-footer">
        <div className="container">
          <div className="footer-bottom">
            <p>&copy; 2025 Literally Possible, LLC. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout; 